import Pokedex from "./components/pokedex";

const App = () => {
  return (
    <div className="container">
      <h1 className="title">Pokedex</h1>
      <Pokedex />
    </div>
  );
}

export default App;